<template>
  <el-dialog
    @closed="dialogClose"
    title="退稿申诉"
    :visible.sync="localDialogVisible"
    width="45%"
  >
    <el-form
      label-suffix="："
      :label-position="labelPosition"
      label-width="100px"
      :model="form"
    >
      <!--      <span style="display: flex; justify-content: center; font-size: 15px">-->
      <el-form-item label="申诉资料">
        <span>{{ resourceTitle }}</span>
      </el-form-item>
      <el-form-item required label="申诉问题">
        <el-input
          maxlength="50"
          placeholder="请描述您遇到的问题，不超过50字"
          v-model="form.question"
        ></el-input>
      </el-form-item>
      <span v-show="formCheck.question" class="must-tip">
        <img
          src="../assets/images/must-tip-icon.png"
          alt=""
          class="must-tip-icon"
        />
        <span>必填项</span>
      </span>
      <el-form-item required label="申诉描述">
        <el-input
          maxlength="200"
          type="textarea"
          :rows="4"
          placeholder="对您的问题进行详细描述，不超过200个字，下方可添加图片说明"
          v-model="form.desc"
        ></el-input>
      </el-form-item>
      <span v-show="formCheck.desc" class="must-tip">
        <img
          src="../assets/images/must-tip-icon.png"
          alt=""
          class="must-tip-icon"
        />
        <span>必填项</span>
      </span>
      <el-form-item label="图片说明">
        <span style="color: RGB(192, 196, 204)"
          >格式为jpg、png，数量不超过5张，单张大小不超过2M</span
        >
        <el-upload
          class="audit-uploader"
          :action="uploadUrl"
          list-type="picture-card"
          :on-remove="handleRemove"
          :limit="5"
          :on-success="handleSuccess"
          :on-error="handleError"
          :before-upload="beforeUpload"
          accept=".jpg,.png"
          @on-change="changeUpload"
          :file-list="fileList"
        >
          <i class="el-icon-plus audit-icon"></i>
        </el-upload>
        <el-dialog :visible.sync="imgdialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" class="auditImg" />
        </el-dialog>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="dialogClose">取消</el-button>
      <el-button
        :loading="submitLoading"
        type="primary"
        size="medium"
        @click="submitAudit"
        >提交</el-button
      >
      <br /><br />
      <span>申诉后48小时内处理，请关注站内信的处理结果</span>
    </span>
  </el-dialog>
</template>
<script>
import api from "../assets/js/api";
export default {
  name: "resource-reAudit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    resourceId: {
      type: Number,
      default: 0,
    },
    resourceTitle: {
      type: String,
      default: "",
    },
    resourceCourseId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      submitLoading: false,
      fileList: [],
      dialogImageUrl: "",
      imgdialogVisible: false,
      labelPosition: "right",
      formCheck: {
        question: false,
        desc: false,
      },
      form: {
        question: "",
        desc: "",
      },
      localDialogVisible: this.dialogVisible,
    };
  },
  computed: {
    uploadUrl() {
      return api.shopResource.uploadReAuditImg;
    },
  },
  watch: {
    dialogVisible(newValue) {
      this.localDialogVisible = newValue;
    },
    localDialogVisible(newValue) {
      this.$emit("update:dialogVisible", newValue);
    },
  },
  methods: {
    async submitAudit() {
      this.submitLoading = true;
      this.formCheck = {};
      console.log(this.resourceId);
      if (
        this.form.question == null ||
        this.form.question === "" ||
        this.form.question === undefined
      ) {
        this.formCheck.question = true;
      }
      if (
        this.form.desc == null ||
        this.form.desc === "" ||
        this.form.desc === undefined
      ) {
        this.formCheck.desc = true;
      }
      if (this.formCheck.question === true || this.formCheck.desc === true) {
        this.submitLoading = false;
        return;
      }
      let filePathList = [];
      if (this.fileList && this.fileList.length !== 0) {
        for (let i = 0; i < this.fileList.length; i++) {
          let resp = this.fileList[i].response;
          if (resp.valid && resp.result && resp.result.filePath) {
            filePathList.push(resp.result.filePath);
          }
        }
      }
      let body = {
        entityId: this.resourceId,
        title: this.form.question,
        description: this.form.desc,
        courseId: this.resourceCourseId,
        filePathList: filePathList,
      };
      const postResult = await this.$axios.post(
        api.shopResource.postResourceRejectReAudit,
        body
      );
      console.log(postResult);
      if (postResult.valid && postResult.result) {
        this.$message.success("提交成功");
      } else {
        this.$message.error("提交失败");
      }
      this.dialogClose();
      this.submitLoading = false;
    },
    changeUpload(file, fileList) {
      this.fileList = fileList;
    },
    beforeUpload(file) {
      console.log(file);
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!(isJPG || isPNG)) {
        this.$message.error("格式为jpg、png，数量不超过5张，单张大小不超过2M");
      }
      if (!isLt2M) {
        this.$message.error("格式为jpg、png，数量不超过5张，单张大小不超过2M");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    // eslint-disable-next-line no-unused-vars
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
      if (fileList && fileList.length >= 5) {
        document
          .querySelectorAll(".audit-uploader .el-upload--picture-card")
          .forEach(function (el) {
            el.style.display = "none"; // 将display属性设置为none，隐藏元素
          });
      }
      this.$message.success("上传成功");
    },
    handleError() {
      this.$message.error("上传失败，请重试");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      document
        .querySelectorAll(".audit-uploader .el-upload--picture-card")
        .forEach(function (el) {
          el.style.display = ""; // 将display属性设置为none，隐藏元素
        });
    },
    dialogClose() {
      this.fileList = [];
      this.form = {
        question: "",
        desc: "",
      };
      this.formCheck = {
        question: false,
        desc: false,
      };
      document
        .querySelectorAll(".audit-uploader .el-upload--picture-card")
        .forEach(function (el) {
          el.style.display = ""; // 将display属性设置为none，隐藏元素
        });
      this.localDialogVisible = false;
    },
  },
};
</script>
<style scoped>
::v-deep .el-upload--picture-card,
::v-deep .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
::v-deep .auditImg {
  width: 100px;
  height: 100px;
}
::v-deep .audit-icon {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
::v-deep .el-upload-list__item-status-label {
  display: none !important;
}
.must-tip {
  line-height: 40px;
  display: inline-flex;
  align-items: center;
  .must-tip-icon {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }

  span {
    font-size: 12px;
    color: #fe4509;
  }
}

::v-deep .el-dialog__footer {
  text-align: center;
}
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
  padding: 30px 30px 30px 30px;
}
::v-deep .el-form-item__content {
  width: 540px !important;
  margin-left: 30px !important;
}
::v-deep .el-textarea__inner {
  line-height: 30px !important;
}
</style>
